// 音の遅れの調査用（URL に ?audiodebug=1 を付けたときだけ）。画面の隅に AudioContext の遅延・読み込み状況・
// 押してから処理が始まるまでの時間・画面が止まった最長時間を出す。スマホ実機で原因を切り分けるため。
import { audioStats } from './audio';

export function startAudioDebug() {
  if (!new URLSearchParams(location.search).has('audiodebug')) return;
  const box = document.createElement('pre');
  box.style.cssText =
    'position:fixed;left:4px;top:4px;z-index:9999;margin:0;padding:6px 8px;font:11px/1.35 ui-monospace,monospace;color:#bff;background:rgba(0,0,0,.78);border-radius:6px;pointer-events:none;max-width:70vw;white-space:pre-wrap';
  document.body.appendChild(box);
  let inputDelay = 0;
  let inputMax = 0;
  // 押した瞬間（OS が受け取った時刻）から、こちらの処理が始まるまで
  document.addEventListener(
    'pointerdown',
    (e) => {
      inputDelay = Math.round(performance.now() - e.timeStamp);
      inputMax = Math.max(inputMax, inputDelay);
    },
    { capture: true },
  );
  // 画面が止まった時間（フレームの間隔の最大。直近 5 秒）
  let last = performance.now();
  let gaps: { t: number; gap: number }[] = [];
  const frame = (t: number) => {
    gaps.push({ t, gap: t - last });
    last = t;
    gaps = gaps.filter((g) => t - g.t < 5000);
    requestAnimationFrame(frame);
  };
  requestAnimationFrame(frame);
  setInterval(() => {
    const s = audioStats();
    const jank = Math.round(Math.max(0, ...gaps.map((g) => g.gap)));
    box.textContent = [
      `音: ${s.state} ${s.sampleRate}Hz  遅延 base ${s.baseLatency}ms / 出力 ${s.outputLatency}ms`,
      `効果音 ${s.se}  ジングル ${s.jingle}  BGM 取得 ${s.bgmFetched}  展開 ${s.bgmDecoded.join(',') || '—'}`,
      `BGM 鳴っている ${s.playing ?? '—'}（希望 ${s.want ?? '—'}）`,
      `最後の効果音 ${s.lastSfx ? `${s.lastSfx.key}: ${s.lastSfx.result}（${Math.round((performance.now() - s.lastSfx.at) / 1000)}秒前）` : '—'}`,
      `押した→処理 ${inputDelay}ms（最大 ${inputMax}ms）  画面停止 最長 ${jank}ms/5秒`,
    ].join('\n');
  }, 300);
}
